import React, { useEffect, useState } from 'react';
import GetTaxpayerInfo from '../../Taxpayer/components/GetTaxpayerInfo';
import { Card, Form, Divider, Typography, Row, Col, Select, Input, Button, message, Checkbox, Tooltip, InputNumber } from 'antd';
import { useWindowDimensions } from '../../../utils/hooks';
import { useParams, useHistory } from 'react-router';
import { States, State, Taxpayer } from 'sigt';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import MultipleTransactions from '../../Forms/components/MultipleTransactions';
import axios from 'axios';
import { round } from 'lodash';
import { from } from 'rxjs';
import { DownloadOutlined } from '@ant-design/icons';
import { checkTaxType } from '../../../utils/checkTaxType';
const server = process.env.REACT_APP_SERVER_URL;

const SpecialSettlements: React.FC<SpecialSettlementsProps> = ({ thm, branches, banks, institutions, auth }) => {
  const [data, setData] = useState<any>({ pagos: [] });
  const [sectors, setSectors] = useState<any>([]);
  const [selectedSector, setSelectedSector] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [appMonto, setAppMonto] = useState(0);
  const [montoCobraya, setMontoCobraya] = useState(0);
  const [metros, setMetros] = useState(0);
  const [folios, setFolios] = useState(0);
  const [kilos, setKilos] = useState(0);
  const [unidades, setUnidades] = useState(0);
  const [hect, setHect] = useState(1);
  const [montod, setMontoD] = useState(1);
  const [esVigente, setEsVigente] = useState(false);
  const [ramoTitle, setRamoTitle] = useState('Seleccione un propósito');
  const [blockMonto, setBlockMonto] = useState(false);
  const [hideSub, setHideSub] = useState(false);
  const [files, setFiles] = useState<{ [P: string]: File } | null>(null);
  const [taxType, setTaxType] = useState('');

  const { width } = useWindowDimensions();
  const { id } = useParams<{ id: any }>();
  const history = useHistory();
  const [form] = Form.useForm();

  const selectedInstitution = institutions?.find((i) => i.id === 9);
  const petro = useSelector((state: State) => state.coin.petro);
  const ut = useSelector((state: State) => state.ut.ut);
  const moneda = useSelector((state: State) => state.coin.moneda);
  const euro = useSelector((state: State) => state.coin.euro);
  const dolar = useSelector((state: State) => state.coin.dolar);
  
  const taxPayer: Taxpayer = (history.location.state as any)?.contribuyente || auth?.user?.contribuyente;
  // const showAll = auth.user?.institucion?.id === 9;
  const showAll = true;
  const cpuBranches = ['111', '123', '124'];
  const sectoresTalonarios = [51, 52, 53, 54, 55];
  const subramosMetros = [2280, 2282, 2284, 2286];

  const inputRango =
    (data.ramo &&
      branches
        .find((b) => b.id === data.ramo)
        ?.descripcion?.toLocaleUpperCase()
        .includes('RANGO%')) ||
    (data.subramo &&
      branches
        .find((b) => b.id === data.ramo)
        ?.subramos.find((s) => s.id === data.subramo)
        ?.descripcion?.toLocaleUpperCase()
        .includes('RANGO%'))
      ? {
          label: 'Porcentaje %',
          message: 'porcentaje',
          placeholder: 'Porcentaje %',
        }
      : {
          label: 'Valor UCTEF',
          message: 'valor UCTEF',
          placeholder: 'Valor UCTEF',
        };

  const findMinMaxFromString = (str, defaultValue = 0) => {
    let ramo = branches?.find((b) => b?.id === data?.ramo)?.descripcion ?? '';
    let subramo = branches?.find((b) => b?.id === data?.ramo)?.subramos?.find((s) => s?.id === data?.subramo)?.descripcion ?? '';

    const rangoIndex = ramo.toUpperCase().indexOf('RANGO') ?? '';
    const rangoSubramoIndex = subramo.toUpperCase().indexOf('RANGO');

    if (rangoIndex === -1 && rangoSubramoIndex === -1) {
      return { min: defaultValue, max: defaultValue };
    }

    let min = defaultValue;
    let max = defaultValue;

    const rangoStr = rangoIndex === -1 ? subramo.substring(rangoSubramoIndex) : ramo.substring(rangoIndex);
    const match = rangoStr.match(/\d+/g);
    if (match) {
      min = Math.min(...match.map((m) => Number(m)));
      max = Math.max(...match.map((m) => Number(m)));
    }
    return { min, max };
  };

  useEffect(() => {
    if (auth?.user?.tipoUsuario === 4 && !id) {
      if (auth?.user?.contribuyente?.id) {
        history.push(`/dashboard/impuestos/especiales/${auth?.user?.contribuyente?.id}`);
      } else {
        history.push('/dashboard');
      }
    }
  }, []);

  useEffect(() => {
    if (auth?.user?.tipoUsuario !== 4) {
      setEsVigente(false);
    }
  }, []);

  useEffect(() => {
    handleGetBranchSector();
  }, []);

  const resetCounters = () => {
    setMetros(0);
    setFolios(0);
    setHect(0);
    setUnidades(0);
    setKilos(0);
    setMontoD(0);
    setAppMonto(0);
  };

  useEffect(() => {
    form.setFieldsValue({ ramo: '' });
    form.setFieldsValue({ subramo: '' });
    form.setFieldsValue({ aplicacion: '' });
    form.setFieldsValue({ ut: 0 });
    form.setFieldsValue({ monto: 0 });
    form.setFieldsValue({ metros: 0 });
    form.setFieldsValue({ folios: 0 });
    form.setFieldsValue({ kilos: 0 });
    form.setFieldsValue({ hect: 0 });
    form.setFieldsValue({ unidades: 0 });
    setData({
      ...data,
      ramo: '',
      subramo: '',
      aplicacion: '',
      ut: 0,
      monto: 0,
      metros: 0,
      folios: 0,
      kilos: 0,
      hect: 0,
      unidades: 0,
    });
    setBlockMonto(false);
    resetCounters();
    getTaxType();
  }, [selectedSector]);

  useEffect(() => {
    form.setFieldsValue({ subramo: '' });
    form.setFieldsValue({ aplicacion: '' });
    form.setFieldsValue({ ut: 0 });
    setData({ ...data, subramo: '', aplicacion: '', ut: 0 });
    resetCounters();
    getTaxType();
  }, [data.ramo]);

  useEffect(() => {
    if (!(history.location.state as any)?.contribuyente || (history.location.state as any)?.contribuyente?.id !== id) {
      history.push('/dashboard/impuestos/especiales');
    }
    if (auth.user?.institucion?.nombreCorto !== 'SAGAS' && auth.user?.institucion?.nombreCompleto !== 'CPU') {
      history.goBack();
    }
    // eslint-disable-next-line
  }, []);

  const limitUt = (value: number) => {
    let newUt = value;
    // if (taxPayer?.tipoContribuyente === 'NATURAL' && value > 10) {
    //   newUt = 10;
    // } else if (value > 500) {
    //   newUt = 500;
    // }
    return newUt;
  };

  const limitBs = (value: number) => {
    let newBs = value;
    // const nLimit = round(10 * round((petro * ut) / 100, 2), 2);
    // const jLimit = round(500 * round((petro * ut) / 100, 2), 2);
    // if (taxPayer?.tipoContribuyente === 'NATURAL' && value > nLimit) {
    //   newBs = nLimit;
    // } else if (value > jLimit) {
    //   newBs = jLimit;
    // }
    return newBs;
  };

  useEffect(() => {
    if (data.ramo) {
      let bran = branches.find((b) => b.id === data.ramo);
      let subBran = bran?.subramos?.find((s) => s.id === data.subramo);
      let montoFoliosUT = folios ? 2 + (folios - 1) : 0;
      let montoFoliosBs = round(montoFoliosUT * round((petro * ut) / 100, 2), 2);
      setRamoTitle(bran?.descripcion || 'Seleccione un propósito');
      if (data.ramo === 498) {
        form.setFieldsValue({ monto: limitBs(round((form.getFieldValue('ut') || 0) * round((petro * ut) / 100, 2), 2)) });
        setMontoCobraya(limitBs(round((form.getFieldValue('ut') || 0) * round((petro * ut) / 100, 2), 2)));
        setBlockMonto(true);
      } else if (appMonto && appMonto > 0) {
        form.setFieldsValue({ monto: limitBs(appMonto) });
        setMontoCobraya(appMonto);
        setBlockMonto(true);
        form.setFieldsValue({ ut: limitUt(round(round(appMonto || 0, 2) * round(100 / (petro * ut), 2))) });
      } else {
        if (data.subramo) {
          if (subBran?.descripcion.includes('RANGO')) {
            if (subBran?.descripcion.includes('RANGO%')) {
              form.setFieldsValue({ monto: limitBs(round(montod * (form.getFieldValue('ut') / 100), 2)) });
              setMontoCobraya(limitBs(round(montod * (form.getFieldValue('ut') / 100), 2)));
              setBlockMonto(true);
            } else {
              form.setFieldsValue({ monto: limitBs(round((form.getFieldValue('ut') || 0) * round((petro * ut) / 100, 2), 2)) });
              setMontoCobraya(limitBs(round((form.getFieldValue('ut') || 0) * round((petro * ut) / 100, 2), 2)));
              setBlockMonto(true);
            }
          } else if (subBran?.descripcion.includes('%') && !subBran?.descripcion.includes('RANGO')) {
            form.setFieldsValue({
              monto: (round(montod * ((subBran?.monto ?? 0) / 100), 2)),
            });
            form.setFieldsValue({ ut: round(round(montod * ((subBran?.monto ?? 0) / 100), 2) * round(100 / (petro * ut), 2),2) });
            setMontoCobraya((round(montod * ((subBran?.monto ?? 0) / 100), 2)));
            setBlockMonto(true);
          } else if (subramosMetros.includes(data.subramo)) {
            let subr = bran?.subramos?.find((s) => s.id === data.subramo);
            form.setFieldsValue({
              monto: subr?.monto && subr?.monto > 0 ? limitBs(round(subr?.monto * Math.ceil(metros / 100), 2)) : 0,
            });
            setMontoCobraya(subr?.monto && subr?.monto > 0 ? limitBs(round(subr?.monto * Math.ceil(metros / 100), 2)) : 0);
            form.setFieldsValue({
              ut: subr?.montout && subr?.montout > 0 ? limitUt(round(subr?.montout * Math.ceil(metros / 100), 2)) : 0,
            });
            setBlockMonto(true);
          } else {
            let subr = bran?.subramos?.find((s) => s.id === data.subramo);
            form.setFieldsValue({
              monto: limitBs(
                subr?.monto && subr?.monto > 0
                  ? round(
                      subr?.monto * (metros ? metros : 1) * (kilos ? kilos : 1) * (unidades ? unidades : 1) * (hect ? hect : 1),
                      2
                    )
                  : 0
              ),
              // (
              // subr.descripcion.includes('hectáreas') ? round((bran?.subramos[0]?.monto || 0),2) + round( (subr?.monto * (hect - 1)) ,2)
              // : round(subr?.monto * (metros ? metros : 1),2) ) : 0
            });
            setMontoCobraya(
              limitBs(
                subr?.monto && subr?.monto > 0
                  ? round(
                      subr?.monto * (metros ? metros : 1) * (kilos ? kilos : 1) * (unidades ? unidades : 1) * (hect ? hect : 1),
                      2
                    )
                  : 0
              )
            );
            setBlockMonto(subr?.monto && subr?.monto > 0 ? true : false);
            form.setFieldsValue({
              ut: limitUt(
                (subr?.montout && subr?.montout > 0
                  ? subr?.montout
                  : round(round(subr?.monto || 0, 2) * round(100 / (petro * ut), 2))) *
                  (metros ? metros : 1) *
                  (kilos ? kilos : 1) *
                  (unidades ? unidades : 1) * 
                  (hect ? hect : 1)
              ),
            });
          }
        } else {
          if ((bran?.subramos?.length || 0) > 0) {
            form.setFieldsValue({ monto: 0 });
            setMontoCobraya(0);
            setBlockMonto(false);
            form.setFieldsValue({ ut: 0 });
          } else {
            if (bran?.descripcion.includes('RANGO')) {
              if (bran?.descripcion.includes('RANGO%')) {
                form.setFieldsValue({ monto: limitBs(round(montod * (form.getFieldValue('ut') / 100), 2)) });
                setMontoCobraya(limitBs(round(montod * (form.getFieldValue('ut') / 100), 2)));
                setBlockMonto(true);
              } else {
                form.setFieldsValue({ monto: limitBs(round((form.getFieldValue('ut') || 0) * round((petro * ut) / 100, 2), 2)) });
                setMontoCobraya(limitBs(round((form.getFieldValue('ut') || 0) * round((petro * ut) / 100, 2), 2)));
                setBlockMonto(true);
              }
            } else {
              form.setFieldsValue({
                monto: bran?.descripcion.includes('%') ? ((
                  bran?.monto && bran?.monto > 0
                    ? round(
                        bran?.monto *
                          (data.ramo === 1109 ? (moneda.toLocaleLowerCase() === 'euro' ? euro : dolar) : 1) *
                          (metros ? metros : 1) *
                          (kilos ? kilos : 1) *
                          (unidades ? unidades : 1) *
                          (hect ? hect : 1) *
                          (montod ? montod / 100 : 1) +
                          montoFoliosBs,
                        2
                      )
                    : 0
                )) :
                (limitBs(
                  bran?.monto && bran?.monto > 0
                    ? round(
                        bran?.monto *
                          (data.ramo === 1109 ? (moneda.toLocaleLowerCase() === 'euro' ? euro : dolar) : 1) *
                          (metros ? metros : 1) *
                          (kilos ? kilos : 1) *
                          (unidades ? unidades : 1) *
                          (hect ? hect : 1) *
                          (montod ? montod / 100 : 1) +
                          montoFoliosBs,
                        2
                      )
                    : 0
                ))
                ,
              });
              setMontoCobraya(
                bran?.descripcion.includes('%') ?
                ((
                  bran?.monto && bran?.monto > 0
                    ? round(
                        bran?.monto *
                          (data.ramo === 1109 ? (moneda.toLocaleLowerCase() === 'euro' ? euro : dolar) : 1) *
                          (metros ? metros : 1) *
                          (kilos ? kilos : 1) *
                          (unidades ? unidades : 1) *
                          (hect ? hect : 1) *
                          (montod ? montod / 100 : 1) +
                          montoFoliosBs,
                        2
                      )
                    : 0
                ))
                :
                (limitBs(
                  bran?.monto && bran?.monto > 0
                    ? round(
                        bran?.monto *
                          (data.ramo === 1109 ? (moneda.toLocaleLowerCase() === 'euro' ? euro : dolar) : 1) *
                          (metros ? metros : 1) *
                          (kilos ? kilos : 1) *
                          (unidades ? unidades : 1) *
                          (hect ? hect : 1) *
                          (montod ? montod / 100 : 1) +
                          montoFoliosBs,
                        2
                      )
                    : 0
                ))
              );
              setBlockMonto(bran?.monto && bran?.monto > 0 ? true : false);
              console.log((bran?.monto || 0) * (100 / (petro * ut)))
              console.log((bran?.monto || 0) * (100 / (petro * ut)) * (montod ? montod / 100 : 1))
              form.setFieldsValue({
                ut: bran?.descripcion.includes('%') ?  
                round((
                  (bran?.montout && bran?.montout > 0
                    ? bran?.montout * (data.ramo === 1109 ? (moneda.toLocaleLowerCase() === 'euro' ? euro : dolar) : 1)
                    : (
                        ((bran?.monto || 0) * (data.ramo === 1109 ? (moneda.toLocaleLowerCase() === 'euro' ? euro : dolar) : 1)) * (100 / (petro * ut))
                      )) *
                    (metros ? metros : 1) *
                    (kilos ? kilos : 1) *
                    (unidades ? unidades : 1) *
                    (hect ? hect : 1) *
                    (montod ? montod / 100 : 1) +
                    montoFoliosUT
                ),2) 
                : 
                (limitUt(round(
                  (bran?.montout && bran?.montout > 0
                    ? bran?.montout * (data.ramo === 1109 ? (moneda.toLocaleLowerCase() === 'euro' ? euro : dolar) : 1)
                    : (
                        ((bran?.monto || 0) * (data.ramo === 1109 ? (moneda.toLocaleLowerCase() === 'euro' ? euro : dolar) : 1)) * (100 / (petro * ut))
                      )) *
                    (metros ? metros : 1) *
                    (kilos ? kilos : 1) *
                    (unidades ? unidades : 1) *
                    (hect ? hect : 1) *
                    (montod ? montod / 100 : 1) +
                    montoFoliosUT
                ,2))),
              });
            }
          }
        }
      }
    } else {
      setRamoTitle('Seleccione un propósito');
    }
  }, [branches, data.ramo, data.subramo, montod, metros, folios, kilos, unidades, hect, appMonto, data.ut]);

  const handleAppChange = (id) => {
    const appM = branches.find((b) => b.id === data.ramo)?.aplicaciones?.find((b) => b.id === id)?.monto;
    if (appM) {
      setAppMonto(appM);
    } else {
      setAppMonto(0);
    }
  };

  const submit = async () => {
    let values = await form.validateFields();
    const checkF = (i) => {
      return files ? files.hasOwnProperty(`Comprobante${i + 1}`) : false;
    };
    let notP: Array<any> = [];
    if (values.pagos && values.pagos?.length > 0) {
      values.pagos.map((p, i) => {
        p.i = i;
        p.idInstitucionBanco = p.destino;
        p.destino = banks?.find(
          (b) => b.id === selectedInstitution?.cuentasBancarias?.find((c) => c.id === p.destino)?.banco
        )?.id;
        return p;
      });
      let filterP = values.pagos.filter((p) => p.metodoPago !== 'PUNTO DE VENTA');
      if (filterP && filterP.length > 0) {
        filterP.map((p, i) => {
          p.check = checkF(p.i);
          notP.push(p);
        });
      }
    }
    const hasAllMandatoryTakings =
      auth?.user?.tipoUsuario === 4
        ? esVigente
          ? true
          : notP && notP?.length > 0
          ? !notP.some((p, i) => p.check === false)
          : true
        : true;
    const ingresado = esVigente
      ? 0
      : round(
          values.pagos.reduce((prev, current) => prev + current.costo, 0),
          2
        );
    console.log(esVigente, 'VIGENTE');
    console.log(ingresado, 'ingresado');
    console.log(round(values.monto, 2), 'rounded');
    if (!esVigente && round(values.monto, 2) > ingresado) {
      message.error('El monto de los pagos debe ser igual o mayor al monto de la liquidación');
    } else if (!hasAllMandatoryTakings) {
      message.error('Debe ingresar un comprobante por cada pago');
    } else {
      if (values.subramo === '') {
        delete values.subramo;
      }
      if (values.aplicacion === '') {
        delete values.aplicacion;
      }
      const ramo = (showAll ? branches : branches.filter((b) => cpuBranches.includes(b.codigo || '')))
        .filter((b) => b.liquidacionEspecial)
        .filter((b) => b.sectorID === sectors.find((s) => s.descripcion === selectedSector)?.id_sector_ramo)
        .filter((element) => element.descripcion === values.ramo)[0]?.id;
      values.fechaCancelada = moment(new Date(), 'DD/MM/YYYY');
      values.fechaCancelada = {
        month: values.fechaCancelada.locale('es').format('MMMM'),
        year: parseInt(values.fechaCancelada.locale('es').format('YYYY')),
      };
      values.monto = +(+values.monto / petro).toFixed(8);
      values.impuestos = [
        {
          fechaCancelada: values.fechaCancelada,
          ramo: ramo,
          subramo: values.subramo,
          monto: values.monto,
          aplicacion: values.aplicacion,
        },
      ];
      values.tipoDocumento = taxPayer.tipoDocumento;
      values.documento = taxPayer.documento;
      values.tipoContribuyente = taxPayer.tipoContribuyente;
      values.rim = values.rim ? values.rim : taxPayer.documento;
      if (!esVigente) {
        values.pagos
          .filter((p) => p)
          .forEach((p) => {
            Object.keys(p).forEach((k) => {
              if (moment.isMoment(p[k])) {
                p[k] = p[k].toISOString();
              }
            });
          });
      }
      if (values.pagos) {
        for (let i = 0; i < values.pagos.length; i++) {
          values.pagos[i] = { ...values.pagos[i], id_usuario: auth?.user?.id };
        }
      }
      values.esVigente = esVigente;
      // delete values.metros;
      // delete values.sector;
      // delete values.ut;
      // delete values.unidades;
      setLoading(true);
      try {
        const response = await axios.post(`${server}/settlements/special`, values, {
          headers: { Authorization: `Bearer ${auth.token}` },
        });
        const fd = new FormData();
        let fileCount = 0;
        if (files)
          Object.keys(files).forEach((k) => {
            fd.append('recaudos', files[k]);
            fileCount++;
          });
        if (fileCount > 0) {
          const resp = await axios.post(`${server}/uploads/special/support/${response.data?.solicitud?.id}`, fd, {
            headers: { Authorization: `Bearer ${auth.token}` },
          });
        }
        message.success('Liquidación creada de manera exitosa');
        if (auth?.user?.tipoUsuario !== 4) history.push('/dashboard/impuestos/especiales');
        else history.push('/dashboard');
        if (response.status === 201 && response.data.solicitud.recibo) {
          const win = window.open(response.data.solicitud.recibo, '_blank');
          win?.focus();
        }
        form.resetFields();
        history.push('/dashboard/impuestos/pagar');
      } catch (e) {
        message.error(
          e.response?.data?.error && typeof e.response?.data.error !== 'object'
            ? e.response?.data?.error
            : e.response?.data?.message && typeof e.response?.data?.message !== 'object'
            ? e.response?.data?.message
            : 'Error al crear liquidación'
        );
      } finally {
        setLoading(false);
      }
    }
  };

  const handleGetBranchSector = async () => {
    try {
      const response = await axios.get(`${server}/branches/sectors`, { headers: { Authorization: `Bearer ${auth.token}` } });
      setSectors(response.data.data.sectors);
    } catch (e) {
      message.error('No se pudieron obtener los sectores');
    }
  };

  const getTaxType = () => {
    const idRamo = data?.ramo || 1;
    const idSector = sectors.find((s) => s.descripcion === selectedSector)?.id_sector_ramo || 1;
    const type = checkTaxType(idRamo, idSector);
    setTaxType(type);
  };

  return (
    <Card
      style={{ height: '100%' }}
      title='Liquidaciones de Tasas e Impuestos'
      bodyStyle={{ height: 'calc(100% - 88px)', overflowY: 'scroll', overflowX: 'hidden', border: '1px solid #f0f0f0' }}
      headStyle={{ height: 64, backgroundColor: thm.primaryColor, padding: width < 1200 ? '0 10px' : '0 20px', color: 'white' }}
    >
      {!id && <GetTaxpayerInfo />}
      {id && (
        <Form
          form={form}
          layout='vertical'
          onFinish={submit}
          scrollToFirstError
          onValuesChange={(c, v) => {
            const ramo = (showAll ? branches : branches.filter((b) => cpuBranches.includes(b.codigo || '')))
              .filter((b) => b.liquidacionEspecial)
              .filter((b) => b.sectorID === sectors.find((s) => s.descripcion === selectedSector)?.id_sector_ramo)
              .filter((element) => element.descripcion === v.ramo)[0]?.id;
            form.setFieldsValue(v);
            setData({ ...v, ramo });
          }}
        >
          {(auth?.user?.tipoUsuario !== 4 ||
            (auth?.user?.tipoUsuario === 4 && (auth?.user?.contribuyente?.sucursales?.length || 0) > 1)) && (
            <Divider orientation='left' style={{ marginLeft: -20, marginBottom: 0 }}>
              <Typography.Title ellipsis level={4} style={{ marginLeft: 5 }}>
                Sucursal
              </Typography.Title>
            </Divider>
          )}
          {(auth?.user?.tipoUsuario !== 4 ||
            (auth?.user?.tipoUsuario === 4 && (auth?.user?.contribuyente?.sucursales?.length || 0) > 1)) && (
            <Row gutter={24}>
              <Col xs={24} xl={24}>
                <Form.Item label='Sucursal' name='rim' rules={[{ required: false, message: 'Debe ingresar la sucursal' }]}>
                  <Select placeholder='Seleccione la sucursal'>
                    {taxPayer?.sucursales?.map((s) => (
                      <Select.Option value={s.referenciaMunicipal} key={s.id}>
                        {s.referenciaMunicipal} - {s.denomComercial} - {s.email} - {s.nombreRepresentante} - {s.direccion}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          )}
          <Divider orientation='left' style={{ marginLeft: -20, marginBottom: 0 }}>
            <Typography.Title ellipsis level={4} style={{ marginLeft: 5 }}>
              Liquidación de Tasa o Impuesto
            </Typography.Title>
          </Divider>
          <Row gutter={24}>
            <Col xs={24} xl={24}>
              <Form.Item
                label='Seleccione una categoría'
                name='sector'
                rules={[{ required: true, message: 'Debe seleccionar una categoría' }]}
              >
                <Select placeholder='Seleccione una categoría' showSearch onChange={(value) => setSelectedSector(value)}>
                  {sectors
                    .filter((s) => s.id_sector_ramo !== 20)
                    .filter((s) => s.id_sector_ramo !== (auth?.user?.institucion?.cargo?.id === 98 ? 0 : 45))
                    .sort((a, b) => {
                      return a.descripcion.localeCompare(b.descripcion, undefined, { numeric: true, sensitivity: 'base' });
                    })
                    .map((b) => (
                      <Select.Option value={b.descripcion} key={b.id_sector_ramo}>
                        {b.descripcion}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} xl={24}>
              <Tooltip title={ramoTitle}>
                <Form.Item
                  label='Seleccione timbre fiscal requerido'
                  name='ramo'
                  rules={[{ required: true, message: 'Debe ingresar el propósito' }]}
                >
                  <Select placeholder='Seleccione un propósito' showSearch optionFilterProp='children'>
                    {(showAll ? branches : branches.filter((b) => cpuBranches.includes(b.codigo || '')))
                      .filter((b) => b.liquidacionEspecial)
                      .filter((b) => b.sectorID === sectors.find((s) => s.descripcion === selectedSector)?.id_sector_ramo)
                      .sort((a, b) => {
                        return a.descripcion.localeCompare(b.descripcion, undefined, { numeric: true, sensitivity: 'base' });
                      })
                      .map((b) => (
                        <Select.Option value={b.descripcion} key={b.id}>
                          {b.descripcion}
                        </Select.Option>
                      ))}
                  </Select>
                </Form.Item>
              </Tooltip>
            </Col>
            {data.ramo && data.ramo !== '' && (branches.find((b) => b.id === data.ramo)?.aplicaciones?.length || 0) > 0 && (
              <Col xs={24} xl={16}>
                <Form.Item
                  label='Aplicación del timbre'
                  name='aplicacion'
                  rules={[{ required: true, message: 'Debe escoger una aplicación para el timbre' }]}
                >
                  <Select placeholder='Seleccione una aplicación para el timbre' onChange={(e) => handleAppChange(e)}>
                    {branches
                      .find((b) => b.id === data.ramo)
                      ?.aplicaciones?.map((b) => (
                        <Select.Option value={b.id} key={b.id}>
                          {b.descripcion}
                        </Select.Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
            )}
            {data.ramo &&
              data.ramo !== '' &&
              appMonto === 0 &&
              (branches.find((b) => b.id === data.ramo)?.subramos?.length || 0) > 0 && (
                <Col xs={24} xl={16}>
                  <Form.Item
                    label='Caso Específico'
                    name='subramo'
                    rules={[{ required: true, message: 'Debe ingresar caso específico' }]}
                  >
                    <Select placeholder='Seleccione un caso específico' showSearch optionFilterProp='children'>
                      {branches
                        .find((b) => b.id === data.ramo)
                        ?.subramos?.map((b) => (
                          <Select.Option value={b.id} key={b.id}>
                            {b.descripcion}
                          </Select.Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
              )}
            {((data.ramo &&
              (branches.find((b) => b.id === data.ramo)?.descripcion?.includes('m2') ||
                (data.subramo && subramosMetros.includes(data.subramo)) ||
                branches.find((b) => b.id === data.ramo)?.descripcion?.includes('m3'))) ||
              (data.ramo &&
                (branches.find((b) => b.id === data.ramo)?.subramos[0]?.descripcion?.includes('m2') ||
                  branches.find((b) => b.id === data.ramo)?.subramos[0]?.descripcion?.includes('m3')))) && (
              <Col xs={24} xl={16}>
                <Form.Item
                  label='Metros'
                  name='metros'
                  rules={[{ required: true, message: 'Debe ingresar la cantidad de metros' }]}
                >
                  <InputNumber
                    placeholder='Metros'
                    min={data.subramo && subramosMetros.includes(data.subramo) ? 100 : 0}
                    onChange={(value) => setMetros(value || 0)}
                    // formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={(value) => (value ? value.replace(/Bs\s?|(,*)/g, '') : '')}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
            )}
            {((data.ramo &&
              (branches.find((b) => b.id === data.ramo)?.descripcion?.includes('x kilo') ||
                branches.find((b) => b.id === data.ramo)?.descripcion?.includes('x kilo'))) ||
              (data.ramo &&
                (branches.find((b) => b.id === data.ramo)?.subramos[0]?.descripcion?.includes('x kilo') ||
                  branches.find((b) => b.id === data.ramo)?.subramos[0]?.descripcion?.includes('x kilo')))) && (
              <Col xs={24} xl={16}>
                <Form.Item label='Kilos' name='kilos' rules={[{ required: true, message: 'Debe ingresar la cantidad de kilos' }]}>
                  <InputNumber
                    placeholder='Kilos'
                    onChange={(value) => setKilos(value || 0)}
                    // formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={(value) => (value ? value.replace(/Bs\s?|(,*)/g, '') : '')}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
            )}
            {((data.ramo && branches.find((b) => b.id === data.ramo)?.descripcion?.includes('x unidad')) ||
              (data.ramo &&
                branches
                  .find((b) => b.id === data.ramo)
                  ?.subramos.find((s) => s.id === data.subramo)
                  ?.descripcion?.includes('x unidad'))) && (
              <Col xs={24} xl={16}>
                <Form.Item
                  label='Unidades'
                  name='unidades'
                  rules={[{ required: true, message: 'Debe ingresar la cantidad de unidades autorizadas' }]}
                >
                  <InputNumber
                    placeholder='Unidades'
                    onChange={(value) => setUnidades(value || 0)}
                    // formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={(value) => (value ? value.replace(/Bs\s?|(,*)/g, '') : '')}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
            )}
            {((data.ramo && branches.find((b) => b.id === data.ramo)?.descripcion?.includes('hectáreas')) ||
              (data.ramo &&
                data.subramo &&
                branches
                  .find((b) => b.id === data.ramo)
                  ?.subramos.find((s) => s.id === data.subramo)
                  ?.descripcion?.includes('hectáreas'))) && (
              <Col xs={24} xl={16}>
                <Form.Item
                  label='Hectáreas'
                  name='hect'
                  rules={[{ required: true, message: 'Debe ingresar la cantidad de hectáreas' }]}
                >
                  <InputNumber
                    placeholder='Hectáreas'
                    onChange={(value) => setHect(value || 0)}
                    defaultValue={1}
                    min={0}
                    // formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={(value) => (value ? value.replace(/Bs\s?|(,*)/g, '') : '')}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
            )}
            {sectoresTalonarios.includes(sectors.find((s) => s.descripcion === selectedSector)?.id_sector_ramo) && (
              <Col xs={24} xl={16}>
                <Form.Item
                  label='Cantidad de Folios'
                  name='folios'
                  rules={[{ required: true, message: 'Debe ingresar la cantidad de folios (Puede ser 0)' }]}
                >
                  <InputNumber
                    placeholder='Folios'
                    onChange={(value) => setFolios(value || 0)}
                    // formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={(value) => (value ? value.replace(/Bs\s?|(,*)/g, '') : '')}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
            )}
            {((data.ramo && branches.find((b) => b.id === data.ramo)?.descripcion?.includes('%')) ||
              (data.subramo &&
                branches
                  .find((s) => s.id === data.ramo)
                  ?.subramos.find((s) => s.id === data.subramo)
                  ?.descripcion.includes('%'))) && (
              <Col xs={24} xl={16}>
                <Form.Item
                  label='Monto a declarar'
                  name='montod'
                  rules={[{ required: true, message: 'Debe ingresar el monto a declarar' }]}
                >
                  <InputNumber
                    placeholder='Monto a declarar'
                    onChange={(value) => setMontoD(value || 0)}
                    // formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={(value) => (value ? value.replace(/Bs\s?|(,*)/g, '') : '')}
                    style={{ width: '100%', fontSize: 18 }}
                  />
                </Form.Item>
              </Col>
            )}
            {data.ramo && data.ramo === 498 && (
              <Col xs={24} xl={16}>
                <Form.Item
                  label='Descripción del caso'
                  name='desc'
                  rules={[{ required: true, message: 'Debe especificar la descripción del caso' }]}
                >
                  <Input placeholder='Descripción' />
                </Form.Item>
              </Col>
            )}
            {((data.ramo &&
              /\bRANGO\b|\bRANGO%\b/.test(branches.find((b) => b.id === data.ramo)?.descripcion?.toLocaleUpperCase() ?? '')) ||
              (data.subramo &&
                /\bRANGO\b|\bRANGO%\b/.test(
                  branches
                    .find((b) => b.id === data.ramo)
                    ?.subramos.find((s) => s.id === data.subramo)
                    ?.descripcion?.toLocaleUpperCase() ?? ''
                ))) && (
              <Col xs={24} xl={16}>
                <Form.Item
                  label={inputRango.label}
                  name='ut'
                  rules={[{ required: true, message: `Debe ingresar el ${inputRango.message}` }]}
                >
                  <InputNumber
                    min={
                      findMinMaxFromString(
                        branches.find((b) => b.id === data.ramo)?.descripcion ||
                          branches.find((b) => b.id === data.ramo)?.subramos.find((s) => s.id === data.subramo)?.descripcion
                      ).min
                    }
                    max={
                      findMinMaxFromString(
                        branches.find((b) => b.id === data.ramo)?.descripcion ||
                          branches.find((b) => b.id === data.ramo)?.subramos.find((s) => s.id === data.subramo)?.descripcion
                      ).max
                    }
                    placeholder={inputRango.placeholder}
                    // formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={(value) => (value ? value.replace(/Bs\s?|(,*)/g, '') : '')}
                    style={{ width: '100%', fontSize: 18 }}
                  />
                </Form.Item>
              </Col>
            )}
            <Col xs={24} xl={8}>
              <Form.Item
                label='Monto a pagar'
                name='monto'
                rules={[{ required: true, message: 'Debe ingresar el monto de la liquidación' }]}
              >
                <InputNumber
                  placeholder='Monto'
                  disabled={blockMonto}
                  // formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={(value) => (value ? value.replace(/Bs\s?|(,*)/g, '') : '')}
                  style={{ width: '100%', fontSize: 18 }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} xl={8}>
              <Form.Item label='Total MMV' name='ut'>
                <InputNumber
                  placeholder='MMV'
                  disabled={!(data?.ramo === 498)}
                  // formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  // parser={value => value ? value.replace(/Bs\s?|(,*)/g, '') : ''}
                  style={{ width: '100%', fontSize: 18 }}
                />
              </Form.Item>
            </Col>
          </Row>
          {/* {showAll && <Checkbox checked={!esVigente} onChange={(e) => setEsVigente(!e.target.checked)}>Incluir Pago</Checkbox>} */}
          {/* {showAll && auth.user?.tipoUsuario === 4 && <Button type='primary' onClick={() => setEsVigente(!esVigente)} >{esVigente ? 'Incluir Pago' : 'No Incluir Pago'}</Button> } */}
          {!esVigente && showAll && (
            <>
              <Divider orientation='left' style={{ marginLeft: -20, marginBottom: 0 }}>
                <Typography.Title ellipsis level={4} style={{ marginLeft: 5 }}>
                  Datos de Pago
                </Typography.Title>
              </Divider>
              <MultipleTransactions
                selectedInstitution={institutions?.find((i) => i.id === 9)}
                form={form}
                data={data}
                maxCred={0}
                files={files}
                setFiles={setFiles}
                taxType={taxType}
                montoCobraya={montoCobraya}
              />
            </>
          )}
          <Row gutter={12} style={{ marginTop: 10, display: 'flex', justifyContent: 'space-between' }}>
            <Col>
              {auth.user?.tipoUsuario !== 4 && (
                <Button
                  onClick={() =>
                    history.push('/dashboard/impuestos/especiales', {
                      contribuyentes: (history.location.state as any)?.contribuyentes,
                    })
                  }
                >
                  Atrás
                </Button>
              )}
            </Col>
            <Row gutter={12}>
              <Col>
                <Button loading={loading} type='primary' onClick={form.submit}>
                  {esVigente ? 'Liquidar Timbre Fiscal' : 'Pagar Timbre Fiscal'}
                </Button>
              </Col>
            </Row>
          </Row>
        </Form>
      )}
    </Card>
  );
};

const mapStateToProps = (state: State) => ({
  thm: state.thm,
  branches: state.brch.branches,
  banks: state.bk.banks,
  institutions: state.inst.institutions,
  auth: state.auth,
});

export default connect(mapStateToProps)(SpecialSettlements);

interface SpecialSettlementsProps {
  thm: States.ThemeColors;
  branches: States.Branches['branches'];
  banks: States.Banks['banks'];
  institutions: States.Institutions['institutions'];
  auth: States.Auth;
}
